import React, { useState } from 'react';
import '../styles/Header.css';

export default function Header({ user, onLogout }) {
  const [searchVal, setSearchVal]       = useState('');
  const [showDropdown, setShowDropdown] = useState(false);

  const initials = user?.name
    ? user.name.split(' ').map(w => w[0]).join('').slice(0, 2).toUpperCase()
    : 'U';

  const handleLogout = () => {
    setShowDropdown(false);
    if (onLogout) onLogout();
  };

  return (
    <div className="header">
      <div className="header-left">
        
        <div className="station-title">
          <strong>NorisSolutions pvt ltd</strong>
          <span className="year-badge">( 2016 - 2026 )</span>
        </div>
      </div>
      <div className="header-right">
        

        {/* User badge with dropdown */}
        <div
          className="user-badge"
          onClick={() => setShowDropdown(!showDropdown)}
          style={{ position: 'relative' }}
        >
          <span className="user-avatar">{initials}</span>
          <span className="user-name">{user?.name || 'User'} ▾</span>

          {showDropdown && (
            <>
              {/* Backdrop to close on outside click */}
              <div
                className="dropdown-backdrop"
                onClick={(e) => { e.stopPropagation(); setShowDropdown(false); }}
              />
              <div className="user-dropdown" onClick={(e) => e.stopPropagation()}>
                <div className="dropdown-info">
                  <div className="dropdown-avatar">{initials}</div>
                  <div>
                    <div className="dropdown-name">{user?.name}</div>
                    <div className="dropdown-role">Administrator</div>
                  </div>
                </div>
                <hr className="dropdown-divider" />
                <button className="dropdown-item logout-item" onClick={handleLogout}>
  <span style={{marginRight:'6px'}}>
    <i className="bi bi-box-arrow-right"></i>
  </span>
  Logout
</button>
              </div>
            </>
          )}
        </div>
      </div>
    </div>
  );
}
